/**
 * @author varun
 */
angular.module("AppCtrl.select2.service",[]).
	// factory just executes the function and returns the result.
	factory('jvformatResult', function( ){
		return function(state) {
			return "";
		}
	}).
	//assigns a constant or an object literal to the service.
	value('jvformatSelection', function(state){
		return "";
	}).
	// service just executes the function and for the returning function puts a new in front.
	factory('jvid', function(){
		return function(state) {
			return 0;
		}
	}).
	// service when the user changes the model directly instead of changing it from the ui, In that case the directive asks this service to return the object that needs to be rendered here.
	factory('returnObjectForId', ['$http','CONST', function(  $http, CONST ){
		return function(){
			
		}
	}]);